import type { HTMLAttributes } from "react";
import { cn } from "@acdc2/ui/lib/utils";

export function RegionCanvas({
  className,
  children,
  ...props
}: HTMLAttributes<SVGElement>) {
  return (
    <svg
      className={cn("absolute w-full h-full pointer-events-none", className)}
      {...props}
    >
      {children}
    </svg>
  );
}
